export default from './Head';



// WEBPACK FOOTER //
// ./src/components/Head/index.js